/* eslint-disable indent */
import React from "react";
import { Redirect } from "react-router-dom";
//Icons
import * as Icon from "@mui/icons-material";
import { UpgrateNotification } from "pages/UserNotifications/UpgrateNotification";
import NotificationSettings from "pages/Administration/NotificationSettings";
import SupportContacts from "pages/Administration/SupportContacts";
import CauverContact from "pages/SupportAdmin/CauverContact";
import SystemPunchProcessingSettings from "pages/Administration/PunchProcessing/SystemPunchProcessing";
import NotificationPreferences from "pages/UserNotifications/NotificationPreferences";
import MonitoringDashboard from "pages/Monitoring";
import MonitoringDevices from "pages/Monitoring/Devices";
import MonitoringEventTrace from "pages/Monitoring/EventTrace";
// import { ForgotPassword } from "pages/GateKeeper/ForgotPassword";
import { ChangeDomain } from "pages/GateKeeper/ChangeDomain";
import { Login } from "pages/GateKeeper/Login";
import { SendOTP } from "pages/GateKeeper/SendOTP";
//MyZone
import { Calendar } from "pages/MyZone/Calendar";
import { MyLeaves } from "pages/MyZone/MyLeaves";
import MyWorkspaceHome from "pages/MyZone/Home";
import { MyShift } from "pages/MyZone/MyShift";
import { Payslip } from "pages/MyZone/Payslip";
import { IndividualWorkingHours } from "pages/MyZone/WorkingHours";
import { MyZoneApply } from "pages/MyZone/MyZoneApply";
import { EODReports } from "pages/MyZone/EODReport";
//TeamZone

import TeamWorkspaceHome from "pages/TeamZone/Home";
import { LeaveSummary } from "pages/TeamZone/LeaveSummary";
import { PlanShift } from "pages/TeamZone/PlanShift";
import { TeamWorkspaceRoster } from "pages/TeamZone/PlanShift/TeamWorkspaceRoster";
import { ShiftGroupIndex } from "pages/TeamZone/PlanShift/ShiftGroup";
import { Status } from "pages/TeamZone/Attendance/AttendanceStatus/Status";
import { Approve } from "pages/TeamZone/Approve";
import { Reports } from "pages/TeamZone/Reports";
import { TeamEODReports } from "pages/TeamZone/EODReport";
import {
  TeamCheckInPolicy,
  TeamGeoFencedSites,
} from "pages/TeamZone/Settings";
//Administration
import { Companies } from "pages/Administration/Companies";
import { Sites } from "pages/Administration/Sites";
import { Departments } from "pages/Administration/Departments";
import { EditUser } from "pages/Administration/CreateUser/EditUser";
import { Designation } from "pages/Administration/Master/Screens/Designation";
import { EmploymentType } from "pages/Administration/Master/Screens/EmploymentType";
import { Master } from "pages/Administration/Master";
import { Users } from "pages/Administration";
import { ViewMembers } from "pages/Administration/Departments/ViewMembers";
import { ViewCompany } from "pages/Administration/Companies/ViewCompany";
import { NewProjectMain } from "pages/Projects/NewProject";
import { Tasks } from "pages/Projects/Tasks";
import { MyTasks } from "pages/Projects/MyTasks";
import { EditProject } from "pages/Projects/MyProject/EditProject";
import { Project } from "pages/Projects/MyProject";
import { Clients } from "pages/Projects/Clients";
import { ChangePassword } from "pages/GateKeeper/ChangePassword";
import { Attendance } from "pages/TeamZone/Attendance";
import { ProjectDashbard } from "pages/Projects/MyProject/ProjectDashboard";
import { SprintDashboard } from "pages/Projects/MyProject/ProjectDashboard/SprintDashboard";
import { ProjectReports } from "pages/Projects/Reports";
//PayRoll
import { PayrollReportsHub } from "pages/PayRoll/Reports";
import { PayrollStatutoryHub } from "pages/PayRoll/Statutory";
import { ShiftAssignIndex } from "pages/TeamZone/PlanShift/ShiftAssign";
import { NewPassword } from "pages/GateKeeper/SendOTP/NewPassword";
import { RoleAndUserGroup } from "pages/Administration/RoleAndUserGroup";
// payroll updated design
import { PayInputs } from "pages/PayRoll/PayInputs";
import { PayrollProcessing } from "pages/PayRoll/PayProcessing";
import { PayrollSetUp } from "pages/PayRoll/Configuration/PayrollConfiguration";
import { PayrollConfiguration } from "pages/PayRoll/Configuration";
import { Disbursement } from "pages/PayRoll/Disbursement";
//HR ZONE
// import { EmployeeDetails } from "pages/HR/EmployeeDetails";
import { CreateEmployee } from "pages/HR/CreateEmployee";
import { EditEmployee } from "pages/HR/EditEmployee";
import { ExistingUser } from "pages/HR/ExistingUser";
import { TimeOffSettings } from "pages/HR/TimeOffSettings";
import { SalaryConfiguration } from "pages/PayRoll/Salary";
import { EODSettings } from "pages/Administration/Settings";
import { EmployeeOnboard } from "pages/HR/EmployeeOnboard";
import { BulkImport } from "pages/HR/EmployeeOnboard/BulkImport";
import { BulkBankImportPage } from "pages/HR/EmployeeOnboard/BulkImport/Bulk_bank_import";
import { HRShift } from "pages/HR/Shift";
import { BulkSalaryImportPage } from "pages/HR/EmployeeOnboard/BulkImport/Bulk_salary_import";
import { BulkEmployeeUpdatePage } from "pages/HR/EmployeeOnboard/BulkImport/Bulk_employee_update";
//Support
import { SupportAdmin } from "pages/SupportAdmin";
import OrganisationDetailsPage, { SystemOrganisationDetailsPage } from "pages/SupportAdmin/Organisation";
import OrganisationContactsPage from "pages/Administration/Organisation/OrganisationContacts";
import OrganisationDevices from "pages/Administration/Organisation/OrganisationDevices";
import OrganisationSettings from "pages/Administration/Organisation/OrganisationSettings";
//Tracking

import WorkSessions from "pages/Operations/WorkSessions";
import SiteRounds from "pages/Operations/SiteRounds";
import { InsufficientPermissions } from "pages/GateKeeper/InsufficientPermissions";

//CRM
import ContactFormPage from "pages/CRM/ContactFormPage";
import EditContactPage from "pages/CRM/EditContactPage";
import DashboardV2 from "pages/CRM/DashboardV2";
import CallLogsPage from "pages/CRM/CallLogsPage";
import ActivitiesPage from "pages/CRM/ActivitiesPage";
import SettingsPage from "pages/CRM/Settings";
import Contacts from "pages/CRM/Contacts";
import CRMCompanies from "pages/CRM/Companies";
import CompanyFormPage from "pages/CRM/CompanyFormPage";
import CompanyDetail from "pages/CRM/CompanyDetail";
import ReminderSummary from "pages/CRM/ReminderSummary";
import CrmReports from "pages/CRM/Daily_report";
import ContactProfilePage from "pages/CRM/ContactProfilePage";

export const getRoutesByRole = (product) => [
  {
    path: "/monitoring/dashboard",
    name: "Monitoring",
    railLabel: "Monitor",
    sidebarOrder: 9,
    icon: Icon.MonitorHeartOutlined,
    component: MonitoringDashboard,
    layout: "/admin",
    hideInSidebar: product ? findAccess(product, "Monitoring") : true,
    collapse: [
      { path: "/admin/monitoring/dashboard", name: "Dashboard", icon: Icon.SpaceDashboard, layout: "/admin" },
      { path: "/admin/monitoring/event-trace", name: "Event Trace", icon: Icon.TimelineRounded, layout: "/admin" },
      { path: "/admin/monitoring/devices", name: "Devices", icon: Icon.DnsOutlined, layout: "/admin" },
    ],
  },
  {
    path: "/monitoring/event-trace",
    name: "Monitoring Event Trace",
    component: MonitoringEventTrace,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/monitoring/devices",
    name: "Monitoring Devices",
    component: MonitoringDevices,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/myzone/calendar",
    // Clicking the "My Workspace" parent lands on Home, not the Calendar. The
    // Calendar route itself stays registered via `path`/`component` below so
    // Home's "View Calendar" links and the visible Calendar submenu row still
    // resolve /admin/myzone/calendar; `uri` only overrides where the parent
    // row navigates (see Sidebar handleItemClick: item.uri || item.path).
    uri: "/myzone/status",
    name: "My Workspace",
    railLabel: "My Work",
    displayName: "My Workspace",
    sidebarOrder: 1,
    icon: Icon.Person,
    component: Calendar,
    layout: "/admin",
    hideInSidebar: product ? findAccess(product, "My Workspace") : true,
    collapse: [
      {
        path: "/admin/myzone/status",
        // `name` must match module_details[].module_name exactly (see
        // Sidebar submenuAccessible) -- the backend now grants this screen
        // under "Home" (was "Status" until a live payload confirmed the
        // rename). `displayName` is what the user actually sees, so the row
        // reads "Home" either way.
        name: "Home",
        displayName: "Home",
        icon: Icon.HomeSharp,
        layout: "/admin",
      },
      {
        path: "/admin/myzone/myworkinghours",
        name: "My Attendance",
        displayName: "My Attendance",
        icon: Icon.AvTimerSharp,
        layout: "/admin",
      },
      {
        // `name` must match module_details[].module_name exactly — the
        // backend now grants this screen under "My Request" (was "Apply"
        // until a live payload confirmed the rename). `displayName` is what
        // the user sees, so the row still reads "My Requests". The old
        // separate "My Leaves" sidebar row is folded into My Requests >
        // Leave; its route stays registered (Home's "Leave Balance" quick
        // link + any deep links still resolve /admin/myzone/myleaves).
        path: "/admin/myzone/apply",
        name: "My Request",
        displayName: "My Requests",
        icon: Icon.ContactPageSharp,
        layout: "/admin",
        // Opts this row into the Sidebar's flyout pattern (see
        // Sidebar/index.js) instead of the default inline-expand, matching
        // Team Workspace > Approve (the only other flyout row) exactly:
        // clicking it only opens the flyout, it does not itself navigate —
        // every destination below is one of the categories the My Requests
        // page (MyZoneApply/index.js) already deep-links via its own
        // ?view=<key> (and, for the shared WorkAdjustment screen's tabs,
        // &tab=<key>) query params.
        flyout: true,
        // Icon + color per item deliberately mirror MyZoneApply/index.js's
        // own requestSidebarSections (its in-page nav rail) exactly — same
        // category, same icon, same hex, same groupLabel text as Team
        // Workspace's own flyout uses for the equivalent group — so this
        // flyout reads as the same navigation, not a differently-styled
        // duplicate of it.
        collapse: [
          {
            // No groupLabel on purpose — this is the standalone landing
            // destination (no ?view=), same as Approve's "Approval Center".
            path: "/admin/myzone/apply",
            name: "Home",
            icon: Icon.GridViewRounded,
            color: "#6D5DF6",
            layout: "/admin",
          },
          {
            groupLabel: "Leave & time off",
            path: "/admin/myzone/apply?view=leave",
            name: "Leave Requests",
            icon: Icon.HolidayVillage,
            color: "#6D5DF6",
            layout: "/admin",
          },
          {
            // Distinct from the existing ?view=compoff/comp-off keys, which
            // already resolve to the separate Off-Day Duty screen below —
            // this is the "Comp Off" attendance-type row that instead opens
            // the shared WorkAdjustment screen on its own tab, same as
            // Permission/On Duty/Break. See the matching useEffect branch
            // added in MyZoneApply/index.js.
            groupLabel: "Leave & time off",
            path: "/admin/myzone/apply?view=work-adjustment&tab=compoff",
            name: "Comp Off",
            icon: Icon.AccessTimeOutlined,
            color: "#F08A24",
            layout: "/admin",
          },
          {
            groupLabel: "Attendance & workday",
            path: "/admin/myzone/apply?view=attendance-correction",
            name: "Attendance Correction",
            icon: Icon.EditCalendarOutlined,
            color: "#12B76A",
            layout: "/admin",
          },
          {
            groupLabel: "Attendance & workday",
            path: "/admin/myzone/apply?view=shift-correction",
            name: "Schedule Change",
            icon: Icon.SwapHorizOutlined,
            color: "#7A5AF8",
            layout: "/admin",
          },
          {
            groupLabel: "Attendance & workday",
            path: "/admin/myzone/apply?view=work-adjustment&tab=permission",
            name: "Permission",
            icon: Icon.VerifiedUserOutlined,
            color: "#2878FF",
            layout: "/admin",
          },
          {
            groupLabel: "Attendance & workday",
            path: "/admin/myzone/apply?view=work-adjustment&tab=onduty",
            name: "On Duty",
            icon: Icon.BadgeOutlined,
            color: "#6D5DF6",
            layout: "/admin",
          },
          {
            groupLabel: "Attendance & workday",
            path: "/admin/myzone/apply?view=work-adjustment&tab=break",
            name: "Break",
            icon: Icon.FreeBreakfastOutlined,
            color: "#0D9488",
            layout: "/admin",
          },
          {
            groupLabel: "Additional work",
            path: "/admin/myzone/apply?view=overtime",
            name: "Overtime",
            icon: Icon.MoreTimeOutlined,
            color: "#F08A24",
            layout: "/admin",
          },
          {
            groupLabel: "Additional work",
            path: "/admin/myzone/apply?view=offday-duty",
            name: "Off-Day Duty",
            icon: Icon.CalendarMonthOutlined,
            color: "#F08A24",
            layout: "/admin",
          },
          {
            groupLabel: "Finance",
            path: "/admin/myzone/apply?view=advance-salary&tab=advance",
            name: "Salary Advance",
            icon: Icon.CreditCardOutlined,
            color: "#2878FF",
            layout: "/admin",
          },
          {
            groupLabel: "Finance",
            path: "/admin/myzone/apply?view=expense",
            name: "Reimbursement",
            icon: Icon.ReceiptLongOutlined,
            color: "#2878FF",
            layout: "/admin",
          },
        ],
      },
      {
        // Was hideInSidebar: true, reachable only via Home's "View
        // Calendar" / "View All Holidays" links -- QA flagged that as a
        // gap (no persistent way to find Calendar). Now a normal visible
        // My Workspace row; the parent route stays the same so those Home
        // links still resolve correctly too.
        path: "/admin/myzone/calendar",
        name: "Calendar",
        icon: Icon.CalendarMonthSharp,
        layout: "/admin",
      },
      {
        path: "/admin/myzone/myshift",
        name: "Shift",
        icon: Icon.PresentToAll,
        layout: "/admin",
      },
      {
        path: "/admin/myzone/payslip",
        name: "Payslip",
        icon: Icon.Summarize,
        layout: "/admin",
      },
      {
        path: "/admin/myzone/eodreport",
        name: "EOD Report",
        displayName: "Daily Report",
        icon: Icon.Assessment,
        layout: "/admin",
      },
    ],
  },
  {
    name: "Workforce Section",
    sectionLabel: "Workforce",
    sidebarOrder: 0.5,
    hideInSidebar: product
      ? findAccess(product, "My Workspace") && findAccess(product, "Team Workspace")
      : true,
  },
  {
    path: "/teamzone/home",
    name: "Team Workspace",
    railLabel: "Team",
    displayName: "Team Workspace",
    sidebarOrder: 2,
    icon: Icon.Diversity3,
    component: TeamWorkspaceHome,
    layout: "/admin",
    hideInSidebar: product ? findAccess(product, "Team Workspace") : true,
    collapse: [
      {
        path: "/admin/teamzone/home",
        name: "Home",
        displayName: "Home",
        icon: Icon.HomeRounded,
        layout: "/admin",
      },
      {
        path: "/admin/teamzone/approve",
        name: "Approvals",
        displayName: "Approvals",
        icon: Icon.PlaylistAddCheckCircle,
        layout: "/admin",
        // Opts this row into the Sidebar's flyout pattern (see
        // Sidebar/index.js) instead of the default inline-expand: clicking
        // it only opens the flyout, it does not itself navigate anywhere —
        // every destination below is one of the categories the Approval
        // Center page (Approve/index.js) already deep-links via its
        // ?view=<key> query param (selectedItemFromView), grouped to match
        // that same page's own buildApprovalOverviewCards groupings.
        flyout: true,
        // Icon + color per item deliberately mirror
        // Approve/index.js's buildApprovalSidebarSections (the in-page
        // "second sidebar" rail) exactly — same category, same icon, same
        // hex — so this flyout reads as the same navigation, not a
        // differently-styled duplicate of it.
        collapse: [
          {
            // No groupLabel on purpose — this is a standalone destination
            // (the landing page itself, no ?view=), not part of any
            // category group, same as how RequestNavRail's own first
            // section holds only this one un-grouped entry above its
            // grouped categories below. Sidebar/index.js's flyout renders a
            // divider after it for the same reason.
            path: "/admin/teamzone/approve",
            name: "Approval Center",
            icon: Icon.PersonOutline,
            color: "#6D5DF6",
            layout: "/admin",
          },
          {
            groupLabel: "Leave & time off",
            path: "/admin/teamzone/approve?view=leave",
            name: "Leave Requests",
            icon: Icon.HolidayVillage,
            color: "#6D5DF6",
            layout: "/admin",
          },
          {
            groupLabel: "Leave & time off",
            path: "/admin/teamzone/approve?view=compoff",
            name: "Comp Off",
            icon: Icon.AccessTimeOutlined,
            color: "#F08A24",
            layout: "/admin",
          },
          {
            groupLabel: "Attendance & workday",
            path: "/admin/teamzone/approve?view=attendance-correction",
            name: "Attendance Correction",
            icon: Icon.EditCalendarOutlined,
            color: "#12B76A",
            layout: "/admin",
          },
          {
            groupLabel: "Attendance & workday",
            path: "/admin/teamzone/approve?view=shift-change",
            name: "Schedule Change",
            icon: Icon.SwapHorizOutlined,
            color: "#7A5AF8",
            layout: "/admin",
          },
          {
            groupLabel: "Attendance & workday",
            path: "/admin/teamzone/approve?view=permission",
            name: "Permission",
            icon: Icon.VerifiedUserOutlined,
            color: "#2878FF",
            layout: "/admin",
          },
          {
            groupLabel: "Attendance & workday",
            path: "/admin/teamzone/approve?view=onduty",
            name: "On Duty",
            icon: Icon.BadgeOutlined,
            color: "#6D5DF6",
            layout: "/admin",
          },
          {
            groupLabel: "Attendance & workday",
            path: "/admin/teamzone/approve?view=break",
            name: "Break",
            icon: Icon.FreeBreakfastOutlined,
            color: "#0D9488",
            layout: "/admin",
          },
          {
            groupLabel: "Additional work",
            path: "/admin/teamzone/approve?view=overtime",
            name: "Overtime",
            icon: Icon.MoreTimeOutlined,
            color: "#F08A24",
            layout: "/admin",
          },
          {
            groupLabel: "Additional work",
            path: "/admin/teamzone/approve?view=offday-duty",
            name: "Off-Day Duty",
            icon: Icon.CalendarMonthOutlined,
            color: "#F08A24",
            layout: "/admin",
          },
          {
            groupLabel: "Finance",
            path: "/admin/teamzone/approve?view=advance-salary",
            name: "Salary Advance",
            icon: Icon.CreditCardOutlined,
            color: "#2878FF",
            layout: "/admin",
          },
          {
            groupLabel: "Finance",
            path: "/admin/teamzone/approve?view=expense",
            name: "Reimbursement",
            icon: Icon.ReceiptLongOutlined,
            color: "#2878FF",
            layout: "/admin",
          },
        ],
      },
      {
        path: "/admin/teamzone/attendance",
        name: "Attendance",
        icon: Icon.PersonAddAlt1,
        layout: "/admin",
      },
      // Team Workspace Calendar temporarily disabled (2026-09-16, per
      // request) -- the screen isn't needed right now, and this entry was
      // metadata-only anyway (already hideInSidebar, no `component`, and no
      // matching top-level route below actually renders TeamZoneCalendar --
      // the two quick links that used to point here were dead links before
      // being commented out too; see LeaveSummaryPanel.js/
      // AttendanceSummaryPanel.js). Restore this block and add a real
      // top-level `{ path: "/teamzone/calendar", component: TeamZoneCalendar, ... }`
      // route if the screen is wanted again.
      // {
      //   path: "/admin/teamzone/calendar",
      //   name: "Calendar",
      //   icon: Icon.CalendarMonthSharp,
      //   layout: "/admin",
      //   hideInSidebar: true,
      // },
      {
        path: "/admin/teamzone/leave-summary",
        name: "Leave Balances",
        displayName: "Leave Balances",
        icon: Icon.TransferWithinAStation,
        layout: "/admin",
      },
      {
        path: "/admin/teamzone/plan-shift",
        name: "Rosters",
        displayName: "Shift Roster",
        icon: Icon.DriveFolderUpload,
        layout: "/admin",
      },
      {
        path: "/admin/teamzone/report",
        name: "Reports",
        icon: Icon.Summarize,
        layout: "/admin",
      },
      // Settings is a flyout row, same pattern as Approvals above: clicking
      // it only opens the floating panel listing the screens below, it does
      // not navigate by itself. Check-In Policy and Geo Fenced Sites used to
      // be tabs of People > Settings; each now has its own flat hidden
      // route further down.
      {
        path: "/admin/teamzone/settings/check-in-policy",
        name: "Settings",
        displayName: "Settings",
        icon: Icon.Settings,
        layout: "/admin",
        flyout: true,
        collapse: [
          {
            path: "/admin/teamzone/settings/check-in-policy",
            name: "Check-In Policy",
            icon: Icon.Fingerprint,
            color: "#6D5DF6",
            layout: "/admin",
          },
          {
            path: "/admin/teamzone/settings/geo-fenced-sites",
            name: "Geo Fenced Sites",
            icon: Icon.EditLocation,
            color: "#0EA5E9",
            layout: "/admin",
          },
        ],
      },
      {
        path: "/admin/teamzone/eodreport",
        name: "EOD Report",
        displayName: "Daily Reports",
        icon: Icon.Assessment,
        layout: "/admin",
        hideInSidebar: true,
      },
    ],
  },
  {
    path: "/payroll/setup",
    // Clicking Payroll in the strip opens Salary > Salary Components (the
    // route above still serves old /admin/payroll/setup links).
    uri: "/payroll/salary/salary-components",
    name: "Payroll",
    railLabel: "Payroll",
    sidebarOrder: 3,
    icon: Icon.ManageAccounts,
    component: PayrollSetUp,
    layout: "/admin",
    hideInSidebar: product ? findAccess(product, "Payroll") : true,
    collapse: [
      {
        path: "/admin/payroll/salary",
        // `name` must stay "Salary Configuration": it is the backend
        // module_name the sidebar checks for access. `displayName` is the
        // label from the new Payroll menu.
        name: "Salary Configuration",
        displayName: "Salary",
        icon: Icon.Payments,
        layout: "/admin",
        // Flyout row, same pattern as Payroll > Reports. Paths follow the
        // PayRoll/Salary folder structure; the hidden /payroll/salary route
        // serves them all and PayRoll/Salary/index.js picks the tab.
        flyout: true,
        collapse: [
          {
            path: "/admin/payroll/salary/salary-components",
            name: "Salary Components",
            icon: Icon.Bento,
            color: "#6D5DF6",
            layout: "/admin",
          },
          {
            path: "/admin/payroll/salary/salary-templates",
            name: "Salary Templates",
            icon: Icon.Sell,
            color: "#12B76A",
            layout: "/admin",
          },
          {
            path: "/admin/payroll/salary/assign-salary/salary-component",
            name: "Assign Salary",
            icon: Icon.AssignmentInd,
            color: "#2878FF",
            layout: "/admin",
          },
          {
            path: "/admin/payroll/salary/salary-revision",
            name: "Salary Revision",
            icon: Icon.TrendingUp,
            color: "#F08A24",
            layout: "/admin",
          },
          {
            path: "/admin/payroll/salary/employee-salary-information",
            name: "Employee Salary",
            icon: Icon.PivotTableChart,
            color: "#7A5AF8",
            layout: "/admin",
          },
        ],
      },
      {
        path: "/admin/payroll/pay-inputs",
        // `name` must stay "Components": it is the backend module_name the
        // sidebar checks for access. `displayName` is the label from the new
        // Payroll menu.
        name: "Components",
        displayName: "Pay Inputs",
        icon: Icon.CreditCard,
        layout: "/admin",
        // Flyout row, same pattern as Payroll > Salary. Paths follow the
        // PayRoll/PayInputs folder structure; the hidden /payroll/pay-inputs
        // route serves them all and PayRoll/PayInputs/index.js picks the
        // screen.
        flyout: true,
        collapse: [
          {
            path: "/admin/payroll/pay-inputs/shift-earnings",
            name: "Shift Earnings",
            icon: Icon.FilterTiltShift,
            color: "#6D5DF6",
            layout: "/admin",
          },
          {
            path: "/admin/payroll/pay-inputs/overtime",
            name: "Overtime",
            icon: Icon.MoreTime,
            color: "#12B76A",
            layout: "/admin",
          },
          {
            path: "/admin/payroll/pay-inputs/leave",
            name: "Leave",
            icon: Icon.HolidayVillage,
            color: "#2878FF",
            layout: "/admin",
          },
          {
            path: "/admin/payroll/pay-inputs/incentives",
            name: "Incentives",
            icon: Icon.AddBusiness,
            color: "#12B76A",
            layout: "/admin",
          },
          {
            path: "/admin/payroll/pay-inputs/incentive-payout",
            name: "Incentive Payout",
            icon: Icon.BrightnessLow,
            color: "#7A5AF8",
            layout: "/admin",
          },
          {
            path: "/admin/payroll/pay-inputs/bonus",
            name: "Bonus",
            icon: Icon.CardGiftcard,
            color: "#F08A24",
            layout: "/admin",
          },
          {
            path: "/admin/payroll/pay-inputs/reimbursements",
            name: "Reimbursements",
            icon: Icon.ReceiptLong,
            color: "#0BA5EC",
            layout: "/admin",
          },
          {
            path: "/admin/payroll/pay-inputs/penalties",
            name: "Penalties",
            icon: Icon.RemoveCircleOutline,
            color: "#E04F5F",
            layout: "/admin",
          },
          {
            path: "/admin/payroll/pay-inputs/damage-and-recovery",
            name: "Damage & Recovery",
            icon: Icon.BuildCircle,
            color: "#7A5AF8",
            layout: "/admin",
          },
          {
            path: "/admin/payroll/pay-inputs/loans-and-advances",
            name: "Loans & Advances",
            icon: Icon.Payments,
            color: "#F08A24",
            layout: "/admin",
          },
          {
            path: "/admin/payroll/pay-inputs/salary-holds",
            name: "Salary Holds",
            icon: Icon.PauseCircleOutline,
            color: "#F79009",
            layout: "/admin",
          },
          {
            path: "/admin/payroll/pay-inputs/security-deposit",
            name: "Security Deposit",
            icon: Icon.Lock,
            color: "#475569",
            layout: "/admin",
          },
          {
            path: "/admin/payroll/pay-inputs/payroll-adjustments",
            name: "Payroll Adjustments",
            icon: Icon.Tune,
            color: "#0D9488",
            layout: "/admin",
          },
        ],
      },
      {
        path: "/admin/payroll/statutory",
        name: "Statutory",
        icon: Icon.Gavel,
        layout: "/admin",
        // No backend "Statutory" module exists yet, so skip the sidebar's
        // module_details access check (see submenuAccessible). Remove this
        // once the backend provisions the module.
        skipAccessCheck: true,
        // Flyout row, same pattern as Payroll > Reports. Paths follow the
        // PayRoll/Statutory folder structure; the hidden /payroll/statutory
        // route below serves them all and PayRoll/Statutory/index.js picks
        // the screen. Every item is a "not implemented yet" placeholder.
        flyout: true,
        collapse: [
          {
            path: "/admin/payroll/statutory/pf",
            name: "PF / EPF",
            icon: Icon.Savings,
            color: "#6D5DF6",
            layout: "/admin",
          },
          {
            path: "/admin/payroll/statutory/esi",
            name: "ESI",
            icon: Icon.LocalHospital,
            color: "#12B76A",
            layout: "/admin",
          },
          {
            path: "/admin/payroll/statutory/pt",
            name: "PT",
            icon: Icon.WorkOutline,
            color: "#2878FF",
            layout: "/admin",
          },
          {
            path: "/admin/payroll/statutory/lwf",
            name: "LWF",
            displayName: "Labour Welfare Fund",
            icon: Icon.Diversity3,
            color: "#F08A24",
            layout: "/admin",
          },
        ],
      },
      {
        path: "/admin/payroll/pay-processing",
        // `name` must stay "Operations": it is the backend module_name the
        // sidebar checks for access. `displayName` is the label from the new
        // Payroll menu.
        name: "Operations",
        displayName: "Pay Processing",
        icon: Icon.Loop,
        layout: "/admin",
        // Flyout row, same pattern as Payroll > Salary. Paths follow the
        // PayRoll/PayProcessing folder structure; the hidden
        // /payroll/pay-processing route serves them all and
        // PayRoll/PayProcessing/index.js picks the screen.
        flyout: true,
        collapse: [
          {
            path: "/admin/payroll/pay-processing/daily-payroll",
            name: "Daily Payroll",
            icon: Icon.LocalActivity,
            color: "#6D5DF6",
            layout: "/admin",
          },
          {
            path: "/admin/payroll/pay-processing/payroll-cycle-run",
            name: "Payroll Cycle Run",
            icon: Icon.Recycling,
            color: "#12B76A",
            layout: "/admin",
          },
        ],
      },
      {
        path: "/admin/payroll/disbursement",
        name: "Disbursement",
        icon: Icon.AccountBalanceWallet,
        layout: "/admin",
        // No backend "Disbursement" module exists yet, so skip the sidebar's
        // module_details access check (see submenuAccessible). Remove this
        // once the backend provisions the module.
        skipAccessCheck: true,
        // Flyout row. Paths follow PayRoll/Disbursement/DisbursementScreen;
        // the hidden /payroll/disbursement route serves them all and
        // PayRoll/Disbursement/index.js picks the screen. Every item is a
        // "not implemented yet" placeholder.
        flyout: true,
        collapse: [
          {
            path: "/admin/payroll/disbursement/salary-payments",
            name: "Salary Payments",
            icon: Icon.Payments,
            color: "#6D5DF6",
            layout: "/admin",
          },
          {
            path: "/admin/payroll/disbursement/loan-payments",
            name: "Loan Payments",
            icon: Icon.RequestQuote,
            color: "#2878FF",
            layout: "/admin",
          },
          {
            path: "/admin/payroll/disbursement/advance-payments",
            name: "Advance Payments",
            icon: Icon.Savings,
            color: "#F08A24",
            layout: "/admin",
          },
          {
            path: "/admin/payroll/disbursement/bank-file-export",
            name: "Bank File Export",
            icon: Icon.FileDownload,
            color: "#0BA5EC",
            layout: "/admin",
          },
          {
            path: "/admin/payroll/disbursement/payment-confirmation",
            name: "Payment Confirmation",
            icon: Icon.TaskAlt,
            color: "#12B76A",
            layout: "/admin",
          },
          {
            path: "/admin/payroll/disbursement/failed-pending-payments",
            name: "Failed / Pending Payments",
            icon: Icon.ErrorOutline,
            color: "#E04F5F",
            layout: "/admin",
          },
          {
            path: "/admin/payroll/disbursement/payment-history",
            name: "Payment History",
            icon: Icon.History,
            color: "#475569",
            layout: "/admin",
          },
        ],
      },
      {
        path: "/admin/payroll/reports",
        name: "Reports",
        icon: Icon.DriveFolderUpload,
        layout: "/admin",
        // Flyout row, same pattern as Team Workspace > Approvals: clicking
        // it only opens the flyout. Paths follow the PayRoll/Reports folder
        // structure; the hidden /payroll/reports route below serves both and
        // PayRoll/Reports/index.js picks the screen from the last segment.
        flyout: true,
        collapse: [
          {
            path: "/admin/payroll/reports/payroll-reports",
            name: "Payroll Reports",
            icon: Icon.ReceiptLong,
            color: "#6D5DF6",
            layout: "/admin",
          },
          {
            path: "/admin/payroll/reports/statutory-reports",
            name: "Statutory Reports",
            icon: Icon.AccountBalance,
            color: "#12B76A",
            layout: "/admin",
          },
        ],
      },
      {
        path: "/admin/payroll/configuration",
        // `name` must stay "Settings": it is the backend module_name the
        // sidebar checks for access (see PayRoll/Configuration/
        // PayrollConfiguration/index.js). `displayName` is the label from
        // the new Payroll menu.
        name: "Settings",
        displayName: "Payroll Settings",
        icon: Icon.Settings,
        layout: "/admin",
        // One line at the bottom of the Payroll menu, below a divider, that
        // never expands. Its pages (Salary, Pay Input, Statutory, Payroll,
        // Disbursement) are listed in a panel inside the page instead
        // (PayRoll/Configuration/payrollSettingsMenu.js); the hidden
        // /payroll/configuration route serves them all.
        sidebarFooter: true,
      },
    ],
  },
  {
    path: "/project/project-management",
    name: "Projects",
    railLabel: "Projects",
    displayName: "Projects",
    sidebarOrder: 6,
    sidebarDividerAfter: true,
    icon: Icon.BusinessCenter,
    component: Project,
    layout: "/admin",
    hideInSidebar: product ? findAccess(product, "Projects") : true,
    collapse: [
      {
        path: "/admin/project/clients",
        name: "Clients",
        icon: Icon.ConnectWithoutContact,
        layout: "/admin",
      },
      {
        path: "/admin/project/project-management",
        name: "Projects",
        icon: Icon.AccountTree,
        layout: "/admin",
      },
      {
        path: "/admin/project/mytask",
        name: "Tasks",
        icon: Icon.Checklist,
        layout: "/admin",
      },
      {
        path: "/admin/project/report",
        name: "Reports",
        icon: Icon.DriveFolderUpload,
        layout: "/admin",
      },
    ],
  },
  {
    path: "/administration/user",
    name: "Administration",
    railLabel: "Admin",
    sidebarOrder: 8,
    icon: Icon.AdminPanelSettings,
    component: Users,
    layout: "/admin",
    hideInSidebar: product ? findAccess(product, "Administration") : true,
    collapse: [
      {
        path: "/admin/administration/companies",
        name: "Companies",
        icon: Icon.Business,
        layout: "/admin",
      },
      {
        path: "/admin/administration/sites",
        name: "Sites",
        icon: Icon.Place,
        layout: "/admin",
      },
      {
        path: "/admin/administration/role/usergroup",
        name: "Roles & User Group",
        icon: Icon.SettingsAccessibility,
        layout: "/admin",
      },
      {
        path: "/admin/administration/user",
        name: "Users",
        icon: Icon.SupervisedUserCircle,
        layout: "/admin",
      },
      // Organisation is a flyout row, same pattern as Team Workspace >
      // Approvals: clicking it only opens the floating panel listing the
      // screens below, it does not navigate by itself. Each screen also has
      // a flat hidden route further down (same dual registration as
      // Notification Settings).
      {
        path: "/admin/administration/organisation/details",
        name: "Organisation",
        icon: Icon.Apartment,
        layout: "/admin",
        flyout: true,
        collapse: [
          {
            path: "/admin/administration/organisation/details",
            name: "Organisation Details",
            icon: Icon.Badge,
            color: "#6D5DF6",
            layout: "/admin",
          },
          {
            path: "/admin/administration/organisation/contacts",
            name: "Contacts",
            icon: Icon.Contacts,
            color: "#0EA5E9",
            layout: "/admin",
          },
          {
            path: "/admin/administration/organisation/devices",
            name: "Devices",
            icon: Icon.DevicesOther,
            color: "#F59E0B",
            layout: "/admin",
          },
          {
            path: "/admin/administration/organisation/settings",
            name: "Settings",
            icon: Icon.Settings,
            color: "#64748B",
            layout: "/admin",
          },
        ],
      },
      {
        path: "/admin/administration/notification-settings",
        name: "Notification Settings",
        icon: Icon.NotificationsActive,
        layout: "/admin",
      },
      {
        path: "/admin/administration/support-contacts",
        name: "Support & Contacts",
        icon: Icon.HeadsetMic,
        layout: "/admin",
      },
    ],
  },
  {
    path: "/hrzone/employees",
    name: "People",
    railLabel: "People",
    displayName: "People",
    sidebarOrder: 7,
    icon: Icon.People,
    component: EmployeeOnboard,
    layout: "/admin",
    hideInSidebar: product ? findAccess(product, "People") : true,
    collapse: [
      {
        path: "/admin/hrzone/employees",
        name: "Employee",
        icon: Icon.Badge,
        layout: "/admin",
      },
      {
        path: "/admin/hrzone/departments",
        name: "Departments",
        icon: Icon.LocationCity,
        layout: "/admin",
      },
      {
        path: "/admin/hrzone/shift",
        name: "Shift",
        icon: Icon.FilterTiltShift,
        layout: "/admin",
      },
      {
        path: "/admin/hrzone/timeoff",
        name: "LMS",
        displayName: "Leave Management",
        icon: Icon.ContactPageSharp,
        layout: "/admin",
      },
      {
        path: "/admin/hrzone/master/designation",
        name: "Master",
        icon: Icon.Person4,
        layout: "/admin",
      },
      {
        path: "/admin/hrzone/settings",
        name: "Settings",
        // People's real provisioning payload provisions this row's module
        // as "Settings" (holding EOD Settings/Check In Policy/Geo Fenced
        // Sites), not the "Feature Configuration" name this used to assume
        // before that payload was checked. Only EOD Settings is still shown
        // here; the other two screens moved to Team Workspace > Settings.
        // permissionName is now redundant
        // with `name` but kept explicit so a future rename of either one
        // doesn't silently break the other.
        permissionName: "Settings",
        icon: Icon.Settings,
        layout: "/admin",
      },
    ],
  },

  {
    path: "/support/admin",
    name: "System Configuration",
    railLabel: "Config",
    sidebarOrder: 9,
    icon: Icon.RecordVoiceOver,
    component: SupportAdmin,
    layout: "/admin",
    hideInSidebar: product ? findAccess(product, "System Configuration") : true,
    collapse: [
      {
        path: "/admin/support/organisation",
        name: "Organisation Details",
        // No backend module of its own yet, so it follows Product Control's
        // provisioning (module "System Configuration").
        permissionName: "System Configuration",
        icon: Icon.Apartment,
        layout: "/admin",
      },
      {
        path: "/admin/support/admin",
        name: "Product Control",
        // Provisioned as module "System Configuration" > submodule "Products".
        permissionName: "System Configuration",
        icon: Icon.Inventory2,
        layout: "/admin",
      },
      {
        path: "/admin/support/system-punch-processing",
        name: "System Punch Processing",
        icon: Icon.SettingsSuggest,
        layout: "/admin",
      },
      {
        path: "/admin/support/cauver-contact",
        name: "Cauver Contact",
        icon: Icon.Contacts,
        layout: "/admin",
      },
    ],
  },
  {
    path: "/operations/worksessions",
    name: "Operations",
    railLabel: "Ops",
    sidebarOrder: 4,
    icon: Icon.Engineering,
    component: WorkSessions,
    layout: "/admin",
    hideInSidebar: product ? findAccess(product, "Operations") : true,
    collapse: [
      {
        path: "/admin/operations/worksessions",
        name: "Work Sessions",
        icon: Icon.QueryStats,
        layout: "/admin",
      },
      {
        path: "/admin/operations/siterounds",
        name: "Site Rounds",
        icon: Icon.LocalPolice,
        layout: "/admin",
      },
    ],
  },
  {
    path: "/crm/contacts/:id",
    name: "CRM",
    component: ContactProfilePage,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/crm/dashboard-v2",
    name: "CRM",
    railLabel: "CRM",
    sidebarOrder: 5,
    icon: Icon.Handshake,
    component: DashboardV2,
    layout: "/admin",
    hideInSidebar: product ? findAccess(product, "CRM") : true,
    collapse: [
      {
        path: "/admin/crm/dashboard-v2",
        name: "Dashboard",
        icon: Icon.SpaceDashboard,
        layout: "/admin",
      },
      {
        path: "/admin/crm/contacts",
        name: "Contacts",
        icon: Icon.Contacts,
        layout: "/admin",
      },
      {
        path: "/admin/crm/companies",
        name: "Companies",
        displayName: "Accounts",
        icon: Icon.Business,
        layout: "/admin",
      },
      {
        path: "/admin/crm/reminder",
        name: "Reminders",
        icon: Icon.NotificationsActive,
        layout: "/admin",
      },
      {
        path: "/admin/crm/crm report",
        name: "Reports",
        icon: Icon.Assessment,
        layout: "/admin",
      },
      {
        path: "/admin/crm/crm-settings",
        name: "Settings",
        icon: Icon.Settings,
        layout: "/admin",
      },
    ],
  },
  {
    path: "/crm/activities",
    name: "CRM",
    component: ActivitiesPage,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/crm/calls",
    name: "CRM",
    component: CallLogsPage,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/crm/contacts",
    name: "CRM",
    component: Contacts,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/crm/create",
    name: "CRM",
    component: ContactFormPage,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/crm/edit/:id",
    name: "CRM",
    component: EditContactPage,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/crm/companies",
    name: "CRM",
    component: CRMCompanies,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/crm/companies/new",
    name: "CRM",
    component: CompanyFormPage,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/crm/companies/:id/edit",
    name: "CRM",
    component: CompanyFormPage,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/crm/companies/:id",
    name: "CRM",
    component: CompanyDetail,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/crm/reminder",
    name: "CRM",
    component: ReminderSummary,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/crm/crm-settings",
    name: "CRM",
    component: SettingsPage,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/crm/crm report",
    name: "CRM",
    component: CrmReports,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/edit/profile",
    name: "Profile",
    // Sidebar renders its existing My Profile panel expanded on this route.
    component: () => null,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/changepassword",
    name: "ChangePassword",
    component: ChangePassword,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    layout: "/auth",
    hideInSidebar: true,
  },
  {
    path: "/send/otp",
    name: "SendOTP",
    component: SendOTP,
    layout: "/auth",
    hideInSidebar: true,
  },
  {
    path: "/otp/newPassword",
    name: "NewPassword",
    component: NewPassword,
    layout: "/auth",
    hideInSidebar: true,
  },
  {
    path: "/maintenance",
    name: "Register",
    component: UpgrateNotification,
    layout: "/auth",
    hideInSidebar: true,
  },
  {
    path: "/project/new-project",
    name: "NewProject",
    component: NewProjectMain,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/project/task",
    name: "Task",
    component: Tasks,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/project/mytask",
    name: "Tasks",
    component: MyTasks,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/project/report",
    name: "Reports",
    component: ProjectReports,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/project/clients",
    name: "Clients",
    component: Clients,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/project/edit/project",
    name: "EditProject",
    component: EditProject,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/project/dashboard",
    name: "Projects",
    component: ProjectDashbard,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/project/sprint/dashboard",
    name: "SprintDashboard",
    component: SprintDashboard,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/administration/edit-user",
    name: "EditUser",
    component: EditUser,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/administration/companies",
    name: "Companies",
    component: Companies,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/administration/sites",
    name: "Sites",
    component: Sites,
    layout: "/admin",
    hideInSidebar: true,
  },
  //MyZone
  {
    path: "/myzone/apply",
    name: "Apply Leave",
    component: MyZoneApply,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/myzone/myleaves",
    name: "Apply Leave",
    component: MyLeaves,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/myzone/status",
    name: "Status",
    component: MyWorkspaceHome,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/myzone/myshift",
    name: "PlanShift",
    component: MyShift,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/myzone/myworkinghours",
    name: "WorkingHours",
    component: IndividualWorkingHours,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/myzone/payslip",
    name: "Payslip",
    component: Payslip,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/myzone/eodreport",
    name: "EOD Report",
    displayName: "Daily Report",
    component: EODReports,
    layout: "/admin",
    hideInSidebar: true,
  },
  //Administration

  {
    path: "/hrzone/departments/view/members",
    name: "PeopleDepartmentMembers",
    component: ViewMembers,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/hrzone/departments",
    name: "Departments",
    component: Departments,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/administration/role/usergroup",
    name: "RoleAndUserGroup",
    component: RoleAndUserGroup,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/administration/department/status",
    name: "DepartmentStatus",
    component: Status,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/administration/department/view/members",
    name: "ViewMembers",
    component: ViewMembers,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/administration/view/company/groups",
    name: "ViewCompany",
    component: ViewCompany,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/administration/department/plan-shift",
    name: "Shift",
    component: PlanShift,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/hrzone/master",
    name: "Master",
    component: Master,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/hrzone/master/designation",
    name: "Designation",
    component: Designation,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/hrzone/master/employment/type",
    name: "EmploymentType",
    component: EmploymentType,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/hrzone/settings",
    name: "Settings",
    component: EODSettings,
    layout: "/admin",
    hideInSidebar: true,
  },
  // Team Zone
  {
    path: "/teamzone/home",
    name: "Home",
    component: TeamWorkspaceHome,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/teamzone/leave-summary",
    name: "Leave Summary",
    component: LeaveSummary,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/teamzone/plan-shift",
    name: "Shift",
    // TeamWorkspaceRoster (RosterAccessGate + PlanShift), not the bare
    // PlanShift used by Administration's own
    // /administration/department/plan-shift entry below — the sidebar
    // already hides Team Workspace's Rosters row without Rosters/Roster
    // viewer access, but Admin.js registers every route unconditionally, so
    // a direct visit or a refresh while already on this page still rendered
    // PlanShift regardless of that permission.
    component: TeamWorkspaceRoster,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/teamzone/shift-group",
    name: "Shift Group",
    component: ShiftGroupIndex,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/teamzone/shift-assignment",
    name: "Shift Roster",
    component: ShiftAssignIndex,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/teamzone/attendance",
    name: "Attendance",
    component: Attendance,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/teamzone/eodreport",
    name: "EOD Report",
    displayName: "Daily Reports",
    component: TeamEODReports,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/attendance/view/members",
    name: "ViewMembers",
    component: ViewMembers,
    layout: "/admin",
    hideInSidebar: true,
  },

  {
    path: "/teamzone/attendances/status",
    name: "Status",
    component: Status,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/teamzone/approve",
    name: "Approve",
    component: Approve,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/teamzone/report",
    name: "Reports",
    component: Reports,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/teamzone/settings/check-in-policy",
    name: "Check-In Policy",
    component: TeamCheckInPolicy,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/teamzone/settings/geo-fenced-sites",
    name: "Geo Fenced Sites",
    component: TeamGeoFencedSites,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/payroll/reports",
    name: "Payroll Reports",
    component: PayrollReportsHub,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/payroll/statutory",
    name: "Statutory",
    component: PayrollStatutoryHub,
    layout: "/admin",
    hideInSidebar: true,
  },

  // updated payroll design
  {
    path: "/payroll/pay-inputs",
    name: "Pay Inputs",
    component: PayInputs,
    layout: "/admin",
    hideInSidebar: true,
  },

  {
    // Old Earnings / Deductions URLs; PayInputs redirects them to the new
    // Pay Inputs paths.
    path: "/payroll/components",
    name: "Components",
    component: PayInputs,
    layout: "/admin",
    hideInSidebar: true,
  },

  {
    path: "/payroll/pay-processing",
    name: "Pay Processing",
    component: PayrollProcessing,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    // Old URL; PayrollProcessing redirects it to the new Pay Processing paths.
    path: "/payroll/operations/processing",
    name: "Payroll Processing",
    component: PayrollProcessing,
    layout: "/admin",
    hideInSidebar: true,
  },

  {
    path: "/payroll/setup",
    name: "Settings",
    component: PayrollSetUp,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/payroll/configuration",
    name: "Configuration",
    component: PayrollConfiguration,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/payroll/disbursement",
    name: "Disbursement",
    component: Disbursement,
    layout: "/admin",
    hideInSidebar: true,
  },

  //HR module
  {
    path: "/hrzone/employees",
    name: "People",
    component: EmployeeOnboard,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/hrzone/edit/employees/:userId?/:pageno?",
    name: "EditEmployee",
    component: EditEmployee,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/hrzone/create_new/employee",
    name: "CreateEmployee",
    component: CreateEmployee,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/hrzone/existing/employee",
    name: "ExistingUser",
    component: ExistingUser,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/hrzone/bulk/import",
    name: "BulkImport",
    component: BulkImport,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/hrzone/bulk/salary-import",
    name: "BulkSalaryImport",
    component: BulkSalaryImportPage,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/hrzone/bulk/bank-import",
    name: "BulkBankImport",
    component: BulkBankImportPage,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/hrzone/bulk/employee-update",
    name: "BulkEmployeeUpdate",
    component: BulkEmployeeUpdatePage,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/change/domain",
    name: "ChangeDomain",
    component: ChangeDomain,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/hrzone/timeoff",
    name: "LMS",
    component: TimeOffSettings,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/payroll/salary",
    name: "Salary Configuration",
    component: SalaryConfiguration,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    // Old URL; SalaryConfiguration redirects it to the new Salary paths.
    path: "/payroll/salaryconfig",
    name: "LMS",
    component: SalaryConfiguration,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/operations/siterounds",
    name: "Site Rounds",
    component: SiteRounds,
    layout: "/admin",
    hideInSidebar: true,
  },

  {
    path: "/insufficient/permissions",
    name: "LMS",
    component: InsufficientPermissions,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/hrzone/shift",
    name: "Shift",
    component: HRShift,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    // Old Incentive page URL; PayInputs redirects it to Pay Inputs >
    // Incentives.
    path: "/payroll/incentive",
    name: "Incentive",
    component: PayInputs,
    layout: "/admin",
    hideInSidebar: true,
  },
  // Flat route (hidden from sidebar) alongside the nested sidebar entry above —
  // same dual-registration pattern used for People Settings, needed so
  // this page is directly linkable without going through the sidebar tree.
  {
    path: "/administration/notification-settings",
    name: "Notification Settings",
    component: NotificationSettings,
    layout: "/admin",
    hideInSidebar: true,
  },
  // Direct route for System Configuration > Organisation.
  {
    path: "/support/organisation",
    name: "Organisation Details",
    component: SystemOrganisationDetailsPage,
    layout: "/admin",
    hideInSidebar: true,
  },
  // Direct route for System Configuration > Cauver Contact.
  {
    path: "/support/cauver-contact",
    name: "Cauver Contact",
    component: CauverContact,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/support/system-punch-processing",
    name: "System Punch Processing",
    component: SystemPunchProcessingSettings,
    layout: "/admin",
    hideInSidebar: true,
  },
  // Keep existing bookmarks working after moving the screen.
  {
    path: "/administration/system-punch-processing",
    name: "Legacy System Punch Processing",
    component: () => <Redirect to="/admin/support/system-punch-processing" />,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/administration/support-contacts",
    name: "Support & Contacts",
    component: SupportContacts,
    layout: "/admin",
    hideInSidebar: true,
  },
  // Flat routes for Administration > Organisation's nested rows.
  {
    path: "/administration/organisation/details",
    name: "Organisation Details",
    component: OrganisationDetailsPage,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/administration/organisation/contacts",
    name: "Organisation Contacts",
    component: OrganisationContactsPage,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/administration/organisation/devices",
    name: "Organisation Devices",
    component: OrganisationDevices,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/administration/organisation/settings",
    name: "Organisation Settings",
    component: OrganisationSettings,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/notifications/preferences",
    name: "Notification Preferences",
    component: NotificationPreferences,
    layout: "/admin",
    hideInSidebar: true,
  },
];

const findAccess = (productDetails, productName) => {
  let module = productDetails.filter((data) => {
    return data.product_name === productName;
  });
  return module.length > 0 ? false : true;
};
